import { render } from "./CustomerIdentifierBatchUpdateModal.vue?vue&type=template&id=c60084fa"
import script from "./CustomerIdentifierBatchUpdateModal.vue?vue&type=script&lang=js"
export * from "./CustomerIdentifierBatchUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__